/* Lazy-init below-the-fold Swipers 300px before they enter view (same pattern as
   fon-index-2026.js): moves their Script Evaluation + forced layouts out of the
   initial-load TBT window. The main product gallery stays EAGER (LCP zone).
   Falls back to immediate init where IntersectionObserver is unsupported. */
function initNearView(el, init) {
  if (!el) return;
  if (!('IntersectionObserver' in window)) { init(); return; }
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { io.disconnect(); init(); }
  }, { rootMargin: '300px 0px' });
  io.observe(el);
}


/* Stop a continuous-autoplay Swiper while it is off screen — it otherwise
   animates (and burns main-thread) for the whole page lifetime. */
function pauseOffscreen(el, sw) {
  if (!el || !sw || !sw.autoplay || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { sw.autoplay.start(); }
    else { sw.autoplay.stop(); }
  }, { rootMargin: '100px 0px' });
  io.observe(el);
}

jQuery(document).ready(function () {


  $(window).on('load',function(){
    if ($(window).width() >= 1040){
      $('#onefit-all-gallery').stickySidebar({
          topSpacing: 110,
          bottomSpacing: 60
      });
    }
  });

  
  $(".main-gallery video[autoplay]").each(function() {
    var video = this;
    var playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch(function() {
        // Autoplay blocked → play on first tap
        $(document).one("touchstart", function() {
          video.play();
        });
      });
    }
  });

  

  $(window).on("scroll", function() {
    var checkoutBtn = $("#fon-checkout-button");

    if (checkoutBtn.length) {
      var scrollTop = $(window).scrollTop();
      var checkoutOffset = checkoutBtn.offset().top;

      if (scrollTop > checkoutOffset) {
        $("body").addClass("scrolled-add-to-cart");
      } else {
        $("body").removeClass("scrolled-add-to-cart");
      }
    }
  });


  let mainSwiper;
let thumbsSwiper;
// Run on load
initSwiper();
function initSwiper() {

  const thumbsSwiper = new Swiper(".swiper-main-gallery-thumbnails", {
  direction: "vertical", // default direction
  spaceBetween: 8,
  slidesPerView: 'auto',
  freeMode: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true,
  loop: false,
  breakpoints: {
    // when window width is <= 768px (mobile)
    0: {
      direction: "horizontal", 
      slidesPerView: 5.5
    },
    // when window width is > 768px (desktop)
    769: {
      direction: "vertical",
    },
  },
});
    // Initialize the main swiper
    // mainSwiper = new Swiper(".main-gallery", {
    //   loop: false,
    //   spaceBetween: 10,
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
    //   pagination: {
    //     el: ".swiper-pagination",
    //     clickable: true,
    //   },
    //   thumbs: {
    //     swiper: thumbsSwiper, // connect to thumbnails
    //   },
    // });



// function toggleActiveSlidePlayer(swiper) {
//   // Pause and mute all slides
//   swiper.slides.forEach(function (slide) {
//     var $player = $(slide).find('mux-player');
//     if (!$player.length) return;

//     $player[0].pause();
//     $player[0].muted = true;
//   });

//   // Play and unmute current slide only
//     var slide = swiper.slides[swiper.activeIndex];
//     var $player = isMobile()
//         ? $(slide).find('.d-flex > mux-player')
//         : $(slide).find('.d-none > mux-player');


//     setTimeout(function(){
//       $player[0].muted = false;
//     $player[0].play().catch(function (e) {
//       console.warn('Mux play failed:', e);
//     });
//     },500);
    




// }

// function reinitMuxPlayer($player) {
//   var player = $player[0];
//   var playbackId = player.getAttribute('playback-id');

//   player.pause();
//   player.removeAttribute('playback-id');
//   player.setAttribute('playback-id', playbackId);
// }


// function isMobile() {
//   return window.innerWidth < 768;
// }



mainSwiper = new Swiper(".main-gallery", {
  loop: false,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  thumbs: {
    swiper: thumbsSwiper,
  }
});


    thumbsSwiper.on('click', function (swiper, e) {
      const clickedIndex = swiper.clickedIndex;
      if (clickedIndex !== undefined) {
        // scroll so that clicked slide is always visible
        thumbsSwiper.slideTo(clickedIndex - 1); // adjust "-2" to show some slides before
      }
    });
  
}








 // Flavour options
 

  $(document).on('click','#fon-oos-button',function(){

      var variantID = $('.fon-flavour.active').attr('data-variant-id');
      // $.magnificPopup.open({
      //   items: {
      //     src: '.klaviyo-oos-' + variantID // This is the ID of the hidden div
      //   },
      //   type: 'inline'
      // });
      showOutOfStockPopup(variantID);
      

  });


  var flavourClick  = 0;
  // $(".flavour-options > div").not(".fon-flavour-oos").on("click", function () {
  $(".flavour-options > div").on("click", function () {

    
    if ($(this).hasClass('fon-flavour-oos') || $(this).hasClass('fon-flavour-force-sold-out')){
      $('body').addClass('selected-variant-oos');
      $('#fon-oos-button').addClass('active');
    }else{
      $('body').removeClass('selected-variant-oos');
      $('#fon-oos-button').removeClass('active');
    }

    flavourClick++;

    // Reset siblings
    $(this).siblings()
      .removeClass("active");

    // Activate this one
    $(this)
    .addClass("active")
    .find(".flavour-color")
    .css({
      "background-color": $(this).data("color"),
      "border-color": $(this).data("color")
    });
    
    // if (isLightColor($(this).data("color"))) {
    //   $(this).addClass("light");
    // }

    var selectedVariantText = $('.fon-flavour.active').attr('data-text');

    // selectedVariantText = '<div class=&quot;metafield-rich_text_field&quot;><p>Taste is personal. Hate it? Instant swap.</p></div>';
    $('.flavour-label').html(selectedVariantText);


    // Product Gallery
    if (flavourClick > 1){
      updateImage();
    }

    var productSKU = $(this).data('flavour-sku');

    switch (productSKU){
      case 'OF-CH-BOX-700-V4.6':
      case 'OF-CM-PCH-700-V4.6':
          productLabel = '#1 rated Chocolate Milkshake';
      break;
      case 'OF-TC-BOX-700-V4.6':
      case 'OF-TC-PCH-700-V4.6':
          productLabel = 'Fruity & Refreshing ';
      break;
      case 'OF-VI-BOX-700-V4.6':
      case 'OF-VI-PCH-700-V4.6':
          productLabel = ' Smooth & Indulgent';
      break;
      case 'OF-FV-BOX-700-V4.6':
      case 'OF-FV-PCH-700-V4.6':
          productLabel = 'Rich & Creamy';
      break;
      case 'OF-CO-BOX-700-V4.6':
      case 'OF-CO-PCH-700-V4.6':
          productLabel = 'Rich & Chocolatey';
      break;
    }
    $('.flavour-detail').html(productLabel);

    $(".flavour-options-wrapper").slideUp();

    var variantTitle = $(this).attr('data-variant-title');
    var variantColor = $(this).attr('data-color');

    $('.selector-swatch').css('background',variantColor);
    $('.selector-text').html(variantTitle);

    checkSelections();
  });


  function updateImage(){
      var selectedVariantID = $('.fon-flavour.active').attr('data-variant-id');
      var selectedVariantImage = $('.fon-flavour.active').attr('data-variant-image');
      var selectedVariantVideo = $('.fon-flavour.active').attr('data-variant-video');
      var selectedVariantImageMobile = $('.fon-flavour.active').attr('data-variant-image-mobile');
      
      var size = parseInt($('[data-size]').data('size'));


      // Cache the active element
      var $active = $('.fon-flavour.active');

   
      for (var i = 0; i < size; i++) {
        var attrName = 'data-gallery-image-' + i;
        var imageURL = $active.attr(attrName);

        console.log(attrName + ' ' + imageURL);

        if (imageURL) {
          // Update thumbnail image
          $('.thumb-index-' + i).find('img').attr('src', imageURL);

          // Update main swiper slide image
          $('.swiper-slide-fon-index-' + i).find('img').attr('src', imageURL);
        }
      }
      

      

    }

   

  var selectedOrFirstAvailableVariantID = $('.flavour-options').attr('data-active-variant');
  $(`.fon-flavour[data-variant-id="${selectedOrFirstAvailableVariantID}"]`).click();
  checkSelections();

 

  // Packaging options
  $("#packaging-options .fon-packaging").on("click", function () {


    var currentFlavour = $('.fon-flavour.active').data('variant-title');

    

    var packagingName = $(this).data('packaging');
    if (packagingName == 'sachets'){
      $('.per-serve-label').html('Sachets');
      $('.per-serve-label-singular').html('sachet');
    }else{
      $('.per-serve-label').html('Scoops');
      $('.per-serve-label-singular').html('scoop');
    }


    $("#packaging-options .fon-packaging").removeClass("active");
    $(this).addClass("active");

    // Hide all flavour option groups
    $(".flavour-options").removeClass("active").find("div").removeClass("active");
        // Show the matching flavour options
        const packaging = $(this).data("packaging");
        $(`#flavour-options-${packaging}`).addClass("active");


        if ($(`#flavour-options-${packaging}`).find('.fon-flavour[data-variant-title="'+currentFlavour+'"]').length){
            $(`#flavour-options-${packaging}`).find('.fon-flavour[data-variant-title="'+currentFlavour+'"]').trigger('click');
        }else{
            checkSelections();
        }
        

    });

  // Quantity picker
  $("#quantity-options > div").on("click", function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    var label = $(this).data("label");
    $('.quantity-options-label p').html(label);
    checkSelections();
  });

  // Paying options
  $("#paying-options > div").on("click", function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    checkSelections();
  });


  checkSelections();

  function checkSelections(){
      checkVariantOption(); if (typeof fonSubSaving === "function") fonSubSaving();
      checkPrices();
      checkCheckout();
      checkAfterPay();

    //    if ($('.fon-packaging.active').data('packaging') == 'sachets'){
    //       $('.dynamic-try-one').html('One-Off Box. 20 Sachets.');
    //       $('.dynamic-try-one').html('One-Off Box. 20 Sachets.');
    //     }else{
    //       $('.dynamic-try-one').html('One-Off Box. 20 Scoops.');
    //     }

      // Floating add to cart
      var originalPrice = $('#fon-subscription-options').find('.original-price').html();
      var salePrice = $('#fon-subscription-options').find('.sale-price').html();

      $('.onefit-all-subscribe-save .save-new-price .price').html(salePrice);
      $('.onefit-all-subscribe-save .save-old-price .price').html(originalPrice);
      $('.onefit-all-onetime-only .save-new-price .price').html(originalPrice);

      if ($('#fon-subscription-options').hasClass('active')){
        $('.onefit-all-subscribe-save').show();
        $('.onefit-all-onetime-only').hide();
      }else{
        $('.onefit-all-subscribe-save').hide();
        $('.onefit-all-onetime-only').show();
      }


      $('.dynamic-selected-flavour').html($('.fon-flavour.active').attr('data-variant-title'));
      $('.dynamic-selected-quantity').html($('.fon-quantity-picker.active').find('p').html());
      

      if ($('div#fon-subscription-options').hasClass('active')){
        $('.dynamic-selected-price').html('Subscription');
      }else{
        $('.dynamic-selected-price').html('One-time');
      }

  }

  /* Which page this add-to-cart came from, for order attribution. Set by the
     buy-box Liquid via #paying-options[data-order-from] so the ?view= offer
     pages are distinguishable from the main PDP. */
  function fonOrderFrom(){
    return $('#paying-options').data('order-from') || 'onefit-short';
  }

  /* ---- Subscribe & Save toggle (?view=onefit-offers only) -------------------
     Off = one-time only; on = reveal the 30/60/90 cards. The underlying
     .fon-subscription-option elements are unchanged, so every existing handler
     (selection, CTA label, add-to-cart) keeps working — the toggle just shows
     the right group and clicks a sensible default within it. */
  function fonSubToggle(on){
    var $rows = $('#fon-buy-type .fon-buy-type__row');
    if (!$rows.length) return;
    $rows.each(function () {
      var mine = ($(this).data('buy-type') === (on ? 'subscribe' : 'onetime'));
      $(this).toggleClass('is-active', mine).attr('aria-checked', mine ? 'true' : 'false');
    });
    /* One-time is fully described by its own row, so the cards collapse; picking
       Subscription drops the 30/60/90 cards down underneath it. The one-time
       option element stays in the DOM and still carries .active so the CTA,
       pricing and add-to-cart keep working unchanged. */
    $('#paying-options')
      .toggleClass('fon-collapsed', !on)
      .toggleClass('fon-subs-hidden', !on)
      .toggleClass('fon-onetime-hidden', on);
    if (on) {
      var term = $('#fon-sub-term').val() || 'subscription-90d';
      var $pick = $('#paying-options > [data-payment-option="' + term + '"]');
      if (!$pick.length) $pick = $('#paying-options > .fon-subscription-option[data-payment-option^="subscription-"]').first();
      $pick.trigger('click');
    } else {
      $('#fon-onetime-option').trigger('click');
    }
  }

  /* Term dropdown inside the Subscription card: picking a frequency selects that
     option (only the chosen one's detail card is shown, via CSS). */
  $(document).on('change', '#fon-sub-term', function () {
    // Picking a frequency implies subscribing — move the row selection too, or the
    // CTA would say "Start My 30 Days" while One-time still looks selected.
    fonSubToggle(true);
  });

  /* Label the toggle with the real saving: one-time price minus the cheapest
     subscription's monthly price. Runs after checkVariantOption() fills them. */
  function fonSubSaving(){
    if (!$('#fon-buy-type').length) return;
    var num = function (sel) {
      var t = $(sel).first().text().replace(/[^0-9.]/g, '');
      return t ? parseFloat(t) : NaN;
    };
    var oneTime = num('[data-dynamic-value="one-time"]');
    var monthly = [num('[data-dynamic-value="90d-monthly"]'),
                   num('[data-dynamic-value="60d-monthly"]'),
                   num('[data-dynamic-value="30d-monthly"]')].filter(function (n) { return !isNaN(n); });
    /* Currency symbol comes from the theme's own mechanism (.with-currency-code
       :before is '$' by default, '£' under .country-GB), so injected prices follow
       the shopper's selected currency instead of a hardcoded dollar sign. */
    var sym = (function () {
      var el = document.querySelector('.with-currency-code');
      if (el) {
        var c = window.getComputedStyle(el, ':before').content;
        if (c && c !== 'none' && c !== 'normal') return c.replace(/["']/g, '');
      }
      return '$';
    })();
    var fmt = function (v) { return sym + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); };
    if (!isNaN(oneTime)) $('[data-buy-type-price="onetime"]').text(fmt(oneTime));

    /* Frequency options carry what each term actually charges, e.g.
       "Delivered every 90 days — $297 billed every 90 days". */
    $('#fon-sub-term option').each(function () {
      var $o = $(this);
      var key = ($o.val() || '').replace('subscription-', '');   // 90d | 60d | 30d
      var days = key.replace('d', '');
      var billed = num('[data-dynamic-value="' + key + '-billed-amount"]');
      var base = 'Delivered every ' + days + ' days';
      $o.text(isNaN(billed) ? base : base + ' \u2014 ' + fmt(billed) + ' billed every ' + days + ' days');
    });
    if (monthly.length) {
      var active = $('.fon-subscription-option.active').attr('data-payment-option') || '';
      var key = active.indexOf('60d') > -1 ? '60d' : active.indexOf('30d') > -1 ? '30d' : '90d';
      var sel = num('[data-dynamic-value="' + key + '-monthly"]');
      var shown = isNaN(sel) ? Math.min.apply(null, monthly) : sel;
      var $p = $('[data-buy-type-price="subscribe"]');
      if (!isNaN(oneTime) && oneTime > shown) {
        $p.html(fmt(shown) + '/mo <s style="opacity:.45;font-weight:400">' + fmt(oneTime) + '</s>');
        // "Subscribe & Save 29%" — the discount for the term currently chosen
        var pct = Math.round((oneTime - shown) / oneTime * 100);
        $('[data-buy-type-label="subscribe"]').text(pct > 0 ? 'Subscribe & Save ' + pct + '%' : 'Subscribe & Save');
      } else {
        $p.text(fmt(shown) + '/mo');
        $('[data-buy-type-label="subscribe"]').text('Subscribe & Save');
      }
    }
  }

  $(document).on('click keydown', '#fon-buy-type .fon-buy-type__row', function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    fonSubToggle($(this).data('buy-type') === 'subscribe');
  });

  function checkAfterPay(){

      var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');
      if (activePaymentPlan == 'subscription'){
        $('.afterpay-text').hide();
      }else{
        $('.afterpay-text').show();
      }

      if (activePaymentPlan == 'onetime'){
        $('#fon-checkout-button').html('Buy One-Time');
        
      }else{

        if (activePaymentPlan == 'subscription-90d'){
          $('#fon-checkout-button').html('Start My 90 Days');
        }else if (activePaymentPlan == 'subscription-60d'){
          $('#fon-checkout-button').html('Start My 60 Days');
        }else if (activePaymentPlan == 'subscription-30d'){
          $('#fon-checkout-button').html('Start My 30 Days');
        }else{
          $('#fon-checkout-button').html('Start My Transformation');
        }
        
      }

  }
  function checkCheckout(){
    var checkoutButton = $('#fon-checkout-button');
    if ($('.fon-subscription-option.active').length){
      checkoutButton.prop('disabled',false);
    }else{
      checkoutButton.prop('disabled',true);
    }
  }

  $(document).on('click', '#fon-checkout-button, .btn-floating-add-to-cart', function () {
    var $btn = $(this);

    // Collect selected values
    var quantityElement = $('.fon-quantity-picker.active');
    var qty = parseInt(quantityElement.attr('data-qty'));

    var selectedVariant = $('.flavour-options > div.active');
    var variantID = selectedVariant.attr('data-variant-id');
    var variantSellingPlanID = selectedVariant.attr('data-selling-plan-id');

    var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');


   
    
    switch (activePaymentPlan){
      case 'onetime':


        var hasBeenOpenedUpsell = localStorage.getItem('hasBeen');
        hasBeenOpenedUpsell = true;

        if (!hasBeenOpenedUpsell){
          localStorage.setItem('hasBeen',1);
          openOl90Popup();
        }else{
          // Prepare data for Shopify AJAX API
          var formData = {
            items: [
              {
                id: variantID,
                quantity: qty
              }
            ]
          };

          formData.items[0].properties = {
            _order_from : fonOrderFrom()
          };

          if (activePaymentPlan === 'subscription' && variantSellingPlanID) {
            formData.items[0].selling_plan = variantSellingPlanID;
            
          }

          // Disable button & show loading state
          var originalText = $btn.text();
          $btn.text('Adding to cart...').prop('disabled', true);

          // AJAX add to cart
          /* Open the drawer NOW, not in the success callback. It renders the cart it
             already has, so it appears immediately and fills in when the add lands.
             Waiting for /cart/add.js meant ~800-1000ms of a dead-looking click. */
          if (typeof FonCartDrawer !== 'undefined') { FonCartDrawer.openCartDrawer(true); }

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify(formData),
            dataType: 'json',
            contentType: 'application/json',
            success: function (response) {
              console.log('Added to cart:', response);

              // ✅ Update and open cart drawer
              if (typeof FonCartDrawer !== 'undefined') {
                FonCartDrawer.updateCartDrawer(response);
                FonCartDrawer.openCartDrawer();
              }

              // ✅ Revert button
              $btn.text(originalText).prop('disabled', false);
            },
            error: function (xhr, status, error) {
              console.error('Error:', error);

              // ❌ Revert button
              $btn.text(originalText).prop('disabled', false);
              alert('Something went wrong. Please try again.');
            }
          });
        }
        

        
      break;
      case 'subscription-60d':
        
        checkout60d($(this),selectedVariant);
      break;
      case 'subscription-90d':
        checkout90d($(this),selectedVariant);
      break;

      case 'subscription-30d':
        
        checkout30d($(this),selectedVariant);
      break;


    }

    
  });

  function checkout90d($btn, selectedVariant) {

    var specialOfferVariantID = selectedVariant.attr('data-90d-variant-id');
    var specialOfferVariantSellingPlanID = selectedVariant.attr('data-90d-variant-selling-plan-id');


    var hasBeenOpenedUpsell = (localStorage.getItem('hasBeen')) ? 'yes' : 'no';

    var formData = {
      items: [
        {
          id: specialOfferVariantID,
          quantity: 5,
          selling_plan: specialOfferVariantSellingPlanID,
          properties : {
            '_BUNDLE' : 'onefit_90d',
            '_bundle_group_id' : 'onefit_90d_' + specialOfferVariantID,
            "_bundle_group_product" : true,
            "_bundle_group_product_row" : 1,
            '_offer' : 'onefit_90d_' + specialOfferVariantID,
            '_offer_product_type' : 'primary',
            '_order_from' : fonOrderFrom(),
            '_upsell_from' : hasBeenOpenedUpsell
          }
        }
      ]
    };

    if (false && !bottleOOS) /*free gift off*/ {
      formData.items.push({
        id: 53301741289656, // Free bottle variant ID
        quantity: 1,
        properties : {
          '_offer' : 'onefit_90d_' + specialOfferVariantID,
          '_offer_product_type' : 'free',
        }
      });
    }

    // Removed May 19, 2026
    if (false && !frotherOOS) /*free gift off*/ {
      formData.items.push({
        id: 51843757670584, // Free frother variant ID
        quantity: 1,
        properties : {
          '_offer' : 'onefit_90d_' + specialOfferVariantID,
          '_offer_product_type' : 'free',
        }
      });
    }

    // Disable button & show loading
    var originalText = $btn.text();
     $btn.text('Preparing your stack...').prop('disabled', true);

    // 1️⃣ Clear cart first
    // $.ajax({
    //   type: 'POST',
    //   url: '/cart/clear.js',
    //   success: function () {

    //     // 2️⃣ Add new items
    //     $.ajax({
    //       type: 'POST',
    //       url: '/cart/add.js',
    //       data: JSON.stringify(formData),
    //       dataType: 'json',
    //       contentType: 'application/json',
    //       success: function () {
    //         setTimeout(function(){
    //           $btn.text(originalText).prop('disabled', false);
    //         },2000);
    //         // 3️⃣ Redirect to checkout
    //         window.location.href = '/checkout';
    //       },
    //       error: function () {
    //         resetButton();
    //         alert('Could not add item to cart. Please try again.');
    //       }
    //     });

    //   },
    //   error: function () {
    //     resetButton();
    //     alert('Could not clear cart. Please try again.');
    //   }
    // });

         // 1️⃣ Check cart first
          // 2️⃣ Add to cart
      /* Open the drawer NOW, not in the success callback. It renders the cart it
         already has, so it appears immediately and fills in when the add lands.
         Waiting for /cart/add.js meant ~800-1000ms of a dead-looking click. */
      if (typeof FonCartDrawer !== 'undefined') { FonCartDrawer.openCartDrawer(true); }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(formData),
        dataType: 'json',
        contentType: 'application/json',
        success: function (addResponse) {
          setTimeout(function(){
            $btn.text(originalText).prop('disabled', false);
          }, 2000);

          if (typeof FonCartDrawer !== "undefined") {
            FonCartDrawer.openCartDrawer();
            FonCartDrawer.updateCartDrawer(addResponse);
          }
        },
        error: function () {
          resetButton();
          alert('Could not add item to cart. Please try again.');
        }
      });
    

    function resetButton() {
      $btn.text(originalText).prop('disabled', false);
    }
  }


  function checkout60d($btn, selectedVariant) {

    var specialOfferVariantID = selectedVariant.attr('data-60d-variant-id');
    var specialOfferVariantSellingPlanID = selectedVariant.attr('data-60d-variant-selling-plan-id');

    var formData = {
      items: [
        {
          id: specialOfferVariantID,
          quantity: 3,
          selling_plan: specialOfferVariantSellingPlanID,
          properties : {
            '_BUNDLE' : 'onefit_60d',
            '_bundle_group_id' : 'onefit_60d_' + specialOfferVariantID,
            "_bundle_group_product" : true,
            "_bundle_group_product_row" : 1,
            '_offer' : 'onefit_60d_' + specialOfferVariantID,
            '_offer_product_type' : 'primary',
            '_order_from' : fonOrderFrom()
          }
        }
      ]
    };

     if (false && !bottleOOS) /*free gift off*/ {
      formData.items.push({
        id: 53301741289656, // Free bottle variant ID
        quantity: 1,
        properties : {
          '_offer' : 'onefit_60d_' + specialOfferVariantID,
          '_offer_product_type' : 'free',
        }
      });
    }


    // Removed May 19, 2026
    if (false && !frotherOOS) /*free gift off*/ {
      formData.items.push({
        id: 51843757670584, // Free frother variant ID
        quantity: 1,
        properties : {
          '_offer' : 'onefit_60d_' + specialOfferVariantID,
          '_offer_product_type' : 'free',
        }
      });
    }

    // if (false && !frotherOOS) /*free gift off*/ {
    //   formData.items.push({
    //     id: 51843757670584, // Free frother variant ID
    //     quantity: 1,
    //     properties : {
    //       _cart_hidden : 'yes'
    //     }
    //   });
    // }

    // Disable button & show loading
    var originalText = $btn.text();
    $btn.text('Preparing your stack...').prop('disabled', true);
         // 1️⃣ Check cart first
              // 2️⃣ Add to cart
        /* Open the drawer NOW, not in the success callback. It renders the cart it
           already has, so it appears immediately and fills in when the add lands.
           Waiting for /cart/add.js meant ~800-1000ms of a dead-looking click. */
        if (typeof FonCartDrawer !== 'undefined') { FonCartDrawer.openCartDrawer(true); }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify(formData),
          dataType: 'json',
          contentType: 'application/json',
          success: function (addResponse) {
            setTimeout(function(){
              $btn.text(originalText).prop('disabled', false);
            }, 2000);

            if (typeof FonCartDrawer !== "undefined") {
            FonCartDrawer.openCartDrawer();
            FonCartDrawer.updateCartDrawer(addResponse);
          }
          },
          error: function () {
            resetButton();
            alert('Could not add item to cart. Please try again.');
          }
        });
      


    // 1️⃣ Clear cart first
    // $.ajax({
    //   type: 'POST',
    //   url: '/cart/clear.js',
    //   success: function () {

    //     // 2️⃣ Add new items
    //     $.ajax({
    //       type: 'POST',
    //       url: '/cart/add.js',
    //       data: JSON.stringify(formData),
    //       dataType: 'json',
    //       contentType: 'application/json',
    //       success: function () {
        
    //         setTimeout(function(){
    //           $btn.text(originalText).prop('disabled', false);
    //         },2000);

    //             // 3️⃣ Redirect to checkout
    //         window.location.href = '/checkout';
    //       },
    //       error: function () {
    //         resetButton();
    //         alert('Could not add item to cart. Please try again.');
    //       }
    //     });

    //   },
    //   error: function () {
    //     resetButton();
    //     alert('Could not clear cart. Please try again.');
    //   }
    // });

    function resetButton() {
      $btn.text(originalText).prop('disabled', false);
    }
  }



  function checkout30d($btn, selectedVariant) {

    var specialOfferVariantID = selectedVariant.attr('data-30d-variant-id');
    var specialOfferVariantSellingPlanID = selectedVariant.attr('data-30d-variant-selling-plan-id');

    var formData = {
      items: [
        {
          id: specialOfferVariantID,
          quantity: 1,
          selling_plan: specialOfferVariantSellingPlanID,
          properties : {
              /* _BUNDLE earns the free bottle (GIFT_RULES.onefit_30d in the cart
                 drawer). The drawer strips gift lines on every update and re-adds
                 them at checkout from these entitlements, so pushing a bottle line
                 here directly would just be deleted. */
              _BUNDLE : 'onefit_30d',
              _bundle_group_id : 'onefit_30d_' + specialOfferVariantID,
              _bundle_group_product : true,
              _bundle_group_product_row : 1,
              _bundle_group_product_multiplier : 1,
              _offer : 'onefit_30d_' + specialOfferVariantID,
              _offer_product_type : 'primary',
              _order_from : fonOrderFrom()
          }
        }
      ]
    };

    // Disable button & show loading
    var originalText = $btn.text();
    $btn.text('Preparing your stack...').prop('disabled', true);
         // 1️⃣ Check cart first
              // 2️⃣ Add to cart
        /* Open the drawer NOW, not in the success callback. It renders the cart it
           already has, so it appears immediately and fills in when the add lands.
           Waiting for /cart/add.js meant ~800-1000ms of a dead-looking click. */
        if (typeof FonCartDrawer !== 'undefined') { FonCartDrawer.openCartDrawer(true); }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify(formData),
          dataType: 'json',
          contentType: 'application/json',
          success: function (addResponse) {
            setTimeout(function(){
              $btn.text(originalText).prop('disabled', false);
            }, 2000);

            if (true) {
              // Cart had items — open drawer
              if (typeof FonCartDrawer !== 'undefined') {
                FonCartDrawer.updateCartDrawer(addResponse);
                FonCartDrawer.openCartDrawer();
              }
            } else {
              // Cart was empty — redirect to checkout
              window.location.href = '/checkout';
            }
          },
          error: function () {
            resetButton();
            alert('Could not add item to cart. Please try again.');
          }
        });
      


    function resetButton() {
      $btn.text(originalText).prop('disabled', false);
    }
  }



  function checkPrices(){
    if ($('.fon-quantity-picker.active').length && $('.flavour-options > div.active').length){

      var selectedVariant = $('.flavour-options > div.active');
      var onetimePrice = selectedVariant.attr("data-one-time-price");
      var subscriptionPrice = selectedVariant.attr("data-subscription-price");

      onetimePrice = onetimePrice / 100;
      subscriptionPrice = subscriptionPrice / 100;
      

      var quantityElement = $('.fon-quantity-picker.active');
      var qty = parseInt(quantityElement.attr('data-qty'));





      

      switch (qty){
        case 1:

          $('div#fon-subscription-options .original-price').html(onetimePrice.toFixed(0));
          $('div#fon-subscription-options .sale-price').html(subscriptionPrice.toFixed(0));
          $('div#fon-onetime-option .sale-price').html(onetimePrice.toFixed(0));

          

        break;
        case 2:
          
          onetimePrice = onetimePrice * qty * .95;
          subscriptionPrice = subscriptionPrice * qty * .95;

          $('div#fon-subscription-options .original-price').html(onetimePrice.toFixed(0));
          $('div#fon-subscription-options .sale-price').html(subscriptionPrice.toFixed(0));
          $('div#fon-onetime-option .sale-price').html(onetimePrice.toFixed(0));


        break;

        case 3:
          
          onetimePrice = onetimePrice * qty * .90;
          subscriptionPrice = subscriptionPrice * qty * .90;

          $('div#fon-subscription-options .original-price').html(onetimePrice.toFixed(0));
          $('div#fon-subscription-options .sale-price').html(subscriptionPrice.toFixed(0));
          $('div#fon-onetime-option .sale-price').html(onetimePrice.toFixed(0));


        break;


        case 4:

          onetimePrice = onetimePrice * qty * .85;
          subscriptionPrice = subscriptionPrice * qty * .85;
          
          $('div#fon-subscription-options .original-price').html(onetimePrice.toFixed(0));
          $('div#fon-subscription-options .sale-price').html(subscriptionPrice.toFixed(0));
          $('div#fon-onetime-option .sale-price').html(onetimePrice.toFixed(0));

        break;
      }

      var savePrice = onetimePrice - subscriptionPrice;
      $('save-price').html(savePrice.toFixed(0));

      var perServeValue = subscriptionPrice / (20 * qty);
      $('.per-serve').html('$'+perServeValue.toFixed(2));

      
    }
  }
  function checkVariantOption(){


    if ($('.fon-packaging.active').data('packaging') == 'sachets'){

      $('.dynamic-option-image').each(function(){
        $(this).attr('src',$(this).attr('data-packaging-sachets'));
      });

    }else{

      $('.dynamic-option-image').each(function(){
        $(this).attr('src',$(this).attr('data-packaging-pouch'));
      });

    }

    
    if ($('.flavour-options > div.active').length){


        // Restart dynamic values
        $("[data-dynamic-value]").removeClass('value-updated');


        var activeSelection = $('.flavour-options > div.active');

        

        var onetimePrice = activeSelection.attr("data-one-time-price");
        var subscriptionPrice = activeSelection.attr("data-subscription-price");

        var priceBasis = onetimePrice / 100;


        var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');


        



         // Slide Down
        $('.fon-subscription-option').not('.active').find('.option-image').removeClass('open');

        if ($('.fon-subscription-option.active').find('.option-image').length){
          // $('.fon-subscription-option.active').find('.option-image').slideDown({
          //   duration: 600,
          //   easing: 'easeOutCubic'
          // });

          $('.fon-subscription-option.active')
          .find('.option-image')
          .addClass('open');

        }


        var selectedSKU = activeSelection.data('flavour-sku');


        var product90d = $('div[data-product="onefit-90-day-supply"] div[data-sku="' + selectedSKU + '"]');

        if (product90d){
            var product90dPrice = parseFloat(product90d.data('price').replace('.00',''));
            var product90dBilledPrice = product90dPrice * 5;
            var product90dPerDay = product90dBilledPrice / 90;
            var product90dMonthly = product90dBilledPrice / 3;


            activeSelection.attr('data-90d-variant-id',product90d.data('variant-id'));
            activeSelection.attr('data-90d-variant-selling-plan-id',product90d.data('selling-plan-id'));

            $('[data-dynamic-value="90d-monthly"]').html(product90dMonthly.toFixed(2).toString().replace('.00','')+'<span class="d-block">/month</span>').addClass('value-updated');
            $('[data-dynamic-value="90d-billed-amount"]').html(product90dBilledPrice.toFixed(2).toString().replace('.00','')).addClass('value-updated');
            $('[data-dynamic-value="90d-per-day"]').html(product90dPerDay.toFixed(2).toString().replace('.00','')).addClass('value-updated');
        }


        var product60d = $('div[data-product="onefit-60-day-supply"] div[data-sku="' + selectedSKU + '"]');
        if (product60d){
          

            var product60dPrice = parseFloat(product60d.data('price'));
            product60dPrice = product60dPrice.toString().replace('.00','');

            var product60dBilledPrice = product60dPrice * 3;
            var product60dPerDay = product60dBilledPrice / 60;
            var product60dMonthly = product60dBilledPrice / 2;

            activeSelection.attr('data-60d-variant-id',product60d.data('variant-id'));
            activeSelection.attr('data-60d-variant-selling-plan-id',product60d.data('selling-plan-id'));

            $('[data-dynamic-value="60d-monthly"]').html(product60dMonthly.toFixed(2).toString().replace('.00','')+'<span class="d-block">/month</span>').addClass('value-updated');
            $('[data-dynamic-value="60d-billed-amount"]').html(product60dBilledPrice.toFixed(2).toString().replace('.00','')).addClass('value-updated');
            $('[data-dynamic-value="60d-per-day"]').html(product60dPerDay.toFixed(2).toString().replace('.00','')).addClass('value-updated');
        }




        /* data-product="onefit-30d", not "onefit": the 30-day option now sells
           the onefit product itself, and a bare "onefit" would be a prefix of
           the other two refs' names. The ref is named for the ROLE it fills,
           not the product behind it. */
        var product30d = $('div[data-product="onefit-30d"] div[data-sku="' + selectedSKU + '"]');
        if (product30d){
          

            var product30dPrice = parseFloat(product30d.data('selling-plan-price'));
            product30dPrice = product30dPrice.toString().replace('.00','');

            var product30dBilledPrice = product30dPrice * 1;
            var product30dPerDay = product30dBilledPrice / 30;
            var product30dMonthly = product30dBilledPrice / 1;

            activeSelection.attr('data-30d-variant-id',product30d.data('variant-id'));
            activeSelection.attr('data-30d-variant-selling-plan-id',product30d.data('selling-plan-id'));

            $('[data-dynamic-value="30d-monthly"]').html(product30dMonthly.toFixed(2).toString().replace('.00','')+'/mo').addClass('value-updated');
            $('[data-dynamic-value="30d-billed-amount"]').html(product30dBilledPrice.toFixed(2).toString().replace('.00','')).addClass('value-updated');
            $('[data-dynamic-value="30d-per-day"]').html(product30dPerDay.toFixed(2).toString().replace('.00','')).addClass('value-updated');
        }




        // One Time
        var oneTimeValue = onetimePrice / 100;
        var oneTimeValuePerServing = oneTimeValue / 20;
        $('[data-dynamic-value="one-time"]').html(oneTimeValue).addClass('value-updated');
        $('[data-dynamic-value="one-time-per-day"]').html(oneTimeValuePerServing).addClass('value-updated');


       
        



    //   if (activePaymentPlan == 'subscription'){
    //     priceBasis = subscriptionPrice / 100;
    //   }
      

    //   var serveBasis = 20;

    //   if ($('.quantity-options-onelife').length){
    //     serveBasis = 30;
    //   }
      
    //   $(".fon-quantity-picker").each(function(index, element) {
    //     var qty = parseInt($(this).attr('data-qty'), 10);
    //     var perServeElement = $(this).find('.value');
    //     var perServeValue = 0;


    //     switch (qty){
    //       case 1:
    //         perServeValue = priceBasis / serveBasis;
    //       break;
    //       case 2:
    //         perServeValue = (priceBasis * qty * 0.95) / (serveBasis * qty);
    //       break;
    //       case 3:
    //         perServeValue = (priceBasis * qty * 0.90) / (serveBasis * qty);
    //       break;
    //       case 4:
    //         perServeValue = (priceBasis * qty * 0.85) / (serveBasis * qty);
    //       break;
    //     }

    //     perServeElement.html(perServeValue.toFixed(2));
        
    //   });

      updateImage();

    }

  }


  $(document).on('click', '.fon-accordion-heading', function () {
    // Remove active from all others
    $('.fon-accordion-heading').not(this).removeClass('active');

    // Toggle only the clicked one
    $(this).toggleClass('active');

    // Smooth scroll to the clicked heading
    $('html, body').animate({
      scrollTop: $(this).offset().top - 100 // adjust offset for sticky headers, etc.
    }, 400); // 400ms = smooth animation duration
  });
initNearView(document.querySelector(".reviews-swiper"), function () {


  var swiper = new Swiper(".reviews-swiper", {
    slidesPerView: 1, // default for desktop
    spaceBetween: 20,
    grabCursor: true,
    loop: true,
    centeredSlides: true, // turned off grid-style center mode
    breakpoints: {
      // when window width is <= 768px (tablet & below)
      768: {
        slidesPerView: 3
      }
    }
  });
});
initNearView(document.querySelector(".swiper-of-all-hall"), function () {

  var swiperHallOfFame = new Swiper(".swiper-of-all-hall", {
    slidesPerView: 1.2,
    spaceBetween: 42,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 42
      }
    }
  });
});
initNearView(document.querySelector(".swiper-of-all-hall-mobile"), function () {
  var swiperHallOfFame = new Swiper(".swiper-of-all-hall-mobile", {
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });
});



  $('.open-supplement-facts').magnificPopup({
    type: 'inline',
    // callbacks: {
    //       open: function() {
    //           console.log('Popup body-inline-bottom');
    //           $('body').addClass('body-popup-slide');
    //       },
    //       close: function() {
    //           console.log('Popup closed');
    //           $('body').removeClass('body-popup-slide');
    //       }
    // },
    // mainClass: 'mfp-animate-bottom',
    // closeMarkup: `
    //   <button title="%title%" type="button" class="mfp-close">
    //     <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
    //       <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
    //     </svg>
    //   </button>
    // `
  });


  // Supplement Facts
  $(document).on("click", ".flavour-options-facts > div", function() {
    // remove active from siblings, add to clicked one
    $(this).addClass("active").siblings().removeClass("active");

    // check if clicked has .flavour-vegan
    if ($(this).hasClass("flavour-vegan")) {
      $(".protein-type").text("Pea Protein");
    } else {
      $(".protein-type").text("Organic Collagen Peptides");
    }
  });


  

  // Helper: check if color is light
  function isLightColor(hex) {
    if (!hex) return false;
    hex = hex.replace("#", "");

    // Expand shorthand (e.g. "fff" → "ffffff")
    if (hex.length === 3) {
      hex = hex.split("").map(c => c + c).join("");
    }

    var r = parseInt(hex.substr(0, 2), 16);
    var g = parseInt(hex.substr(2, 2), 16);
    var b = parseInt(hex.substr(4, 2), 16);

    // Perceived brightness (HSP)
    var brightness = Math.sqrt(
      0.299 * (r * r) +
      0.587 * (g * g) +
      0.114 * (b * b)
    );

    return brightness > 200; // threshold, tweak if needed
  }


function initGallery($gallery) {
  $gallery.on('click', 'picture, video, .d-md-flex mux-player', function (e) {
    e.preventDefault();

    // Mute any mux-player in the gallery
    $gallery.find('mux-player').each(function () {
      this.muted = true;
    });


    var $clicked = $(this);
    var $items = $gallery.find('picture, video, .d-md-flex mux-player');

    var promises = $items.map(function () {
      var $el = $(this);

      if ($el.is('mux-player')) {
        var playbackId = $el.attr('playback-id');
        var poster     = $el.attr('poster') || '';
        return Promise.resolve({
          html:
            '<div style="display:flex;justify-content:center;align-items:center;width:100%;height:100%;">' +
              '<mux-player' +
              ' playback-id="' + playbackId + '"' +
              ' poster="' + poster + '"' +
              ' muted playsinline autoplay loop prefer-playback="mse"' +
              ' no-controls' +
              ' style="--controls:none;--media-object-fit:contain;width:100%;max-height:90vh;">' +
              '</mux-player>' +
            '</div>',
          w: 1920,
          h: 1080
        });
      }

      if ($el.is('video')) {
        return Promise.resolve({
          html:
            '<div style="display:flex;justify-content:center;align-items:center;width:100%;height:100%;">' +
              '<video autoplay muted loop playsinline preload="auto" ' +
              'style="max-width:100%;max-height:100%;width:auto;height:auto;">' +
                '<source src="' + $el.find('source').attr('src') + '" type="video/mp4">' +
                'Your browser does not support the video tag.' +
              '</video>' +
            '</div>',
          w: 1920,
          h: 1080
        });
      }

      // <picture> carries no src — only its inner <img> does. Without this fallback
      // imgSrc is undefined, the browser requests /products/undefined (404), img.onload
      // never fires, Promise.all never settles and the lightbox never opens.
      var imgSrc = $el.data('large') || $el.attr('src') || $el.find('img').attr('src');
      return new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () {
          resolve({ src: imgSrc, w: img.naturalWidth, h: img.naturalHeight });
        };
        img.src = imgSrc;
      });

    }).get();

    Promise.all(promises).then(function (items) {
      var index = $items.index($clicked);
      var pswpElement = document.querySelector('.pswp');

      var options = {
        index: index,
        bgOpacity: 0.9,
        showHideOpacity: true,
        barsSize: { top: 44, bottom: 'auto' },
        shareEl: false,
        fullscreenEl: false,
        zoomEl: false,
        counterEl: false,
        arrowEl: true,
        closeEl: true,
        closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar']
      };

      var lightbox = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

      // Unmute the mux-player in the active slide
      function unmuteActive() {
        var player = pswpElement.querySelector('.pswp__item--active mux-player, .pswp__zoom-wrap mux-player');
        // PhotoSwipe doesn't add --active immediately, so query the current index item
        var items = pswpElement.querySelectorAll('.pswp__item');
        items.forEach(function (item, i) {
          var p = item.querySelector('mux-player');
          if (!p) return;
          if (i === lightbox.getCurrentIndex()) {
            p.muted = false;
          } else {
            p.muted = true;
          }
        });
      }

      // Fires once the first slide is rendered and ready
      lightbox.listen('afterChange', function () {
        unmuteActive();
      });

      // Fires when the initial slide is shown
      lightbox.listen('initialZoomInEnd', function () {
        unmuteActive();
      });

      // Mute everything on close
      lightbox.listen('close', function () {
        pswpElement.querySelectorAll('mux-player').forEach(function (p) {
          p.muted = true;
        });
      });

      lightbox.init();
    });
  });
}


  // Desktop gallery
  initGallery($('.product-main-gallery'));
initNearView(document.querySelector(".onefit-all-marquee-swiper"), function () {

  const marqueeSwiper = new Swiper(".onefit-all-marquee-swiper", {
    slidesPerView: "auto",   // size slides to content
    spaceBetween: 30,        // spacing between
    loop: true,              // seamless repeat
    allowTouchMove: false,   // disable dragging
    speed: 10000,            // how long 1 loop takes (ms) → higher = slower
    autoplay: {
      delay: 0,              // no pause, continuous
      disableOnInteraction: false,
    },
  });
  pauseOffscreen(document.querySelector('.onefit-all-marquee-swiper'), marqueeSwiper);
});

  // $('.fon-flavour-oos').on('click', function () {
  //   let $el = $(this);
  //   $el.addClass('wiggle');
    
  //   // remove after animation ends so it can trigger again
  //   setTimeout(() => {
  //     $el.removeClass('wiggle');
  //   }, 500); // match animation duration
  // });


  // All videos
  const videos = document.querySelectorAll('.onefit-all-videos video');

  // Intersection Observer to trigger play when visible
  let observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      if (entry.isIntersecting) {
        // Try autoplay unmuted
        video.muted = true;
        video.loop = true;
        video.play().catch(err => {
          console.log("Autoplay blocked:", err);
        });

        $('.onefit-all-videos img').fadeOut();
        $('.onefit-all-videos video-media').attr('loaded','true');

      } else {
        video.pause(); // optional: pause when out of view
      }
    });
  }, {
    threshold: 0.1 // at least 50% visible
  });

  videos.forEach(video => observer.observe(video));

  $('.onefit-all-videos .video-container').on('click', function () {
    const $container = $(this);
    const $video = $container.find('video').get(0);
    const $overlay = $container.find('.video-overlay');

    if ($video.muted) {
      // Mute all others and reset overlays
      $('.onefit-all-videos .video-container').each(function () {
        const v = $(this).find('video').get(0);
        v.muted = true;
        $(this).find('.video-overlay').show();
      });

      // Unmute clicked video + hide overlay
      $video.muted = false;
      $overlay.hide();

      if ($video.paused) {
        $video.play().catch(() => {});
      }
    } else {
      // Already unmuted → mute and show overlay
      $video.muted = true;
      $overlay.show();
    }
  });

  // const addToCartSwiper = new Swiper('.swiper-add-to-cart-carousel', {
  //   effect: 'fade',
  //   fadeEffect: {
  //     crossFade: true, // keep enabled for soft transition
  //   },
  //   loop: true,
  //   speed: 700, // shorter fade duration
  //   autoplay: {
  //     delay: 2000, // longer time before next transition
  //     disableOnInteraction: false,
  //   },
  // });
initNearView(document.querySelector(".swiper-add-to-cart-carousel"), function () {

const addToCartSwiper = new Swiper('.swiper-add-to-cart-carousel', {
  slidesPerView: 'auto',
  spaceBetween: 0,
  loop: true,
  freeMode: true,
  freeModeMomentum: false,
  allowTouchMove: false,
  speed: 6000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
});
pauseOffscreen(document.querySelector('.swiper-add-to-cart-carousel'), addToCartSwiper);
});


  const $section = $('#section-whats-inside');
const $container = $section.find('.of-inside-container');

if ($container.length){

  // Duplicate content ONCE
  $container.append($container.html());

  let speed = 0.25;          // visual speed
  let paused = false;
  let currentScroll = 0;    // float accumulator

  // $container.on('mouseenter', () => paused = true);
  // $container.on('mouseleave', () => paused = false);

  var running = false;
  function infiniteScroll() {
    if (!paused) {
      currentScroll += speed;

      const halfHeight = $container[0].scrollHeight / 2;

      if (currentScroll >= halfHeight) {
        currentScroll -= halfHeight; // seamless reset
      }

      $container.scrollTop(Math.floor(currentScroll));
    }

    if (running) requestAnimationFrame(infiniteScroll);
  }

  // Run the marquee only while it is on screen: the rAF loop otherwise burns
  // main-thread time for the whole page lifetime (shows as large TBT in traces).
  if ('IntersectionObserver' in window) {
    var marqueeVis = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        if (!running) { running = true; requestAnimationFrame(infiniteScroll); }
      } else {
        running = false;
      }
    }, { rootMargin: '100px 0px' });
    marqueeVis.observe($container[0]);
  } else {
    running = true;
    requestAnimationFrame(infiniteScroll);
  }
}

const storeStatuses = document.querySelectorAll('.store-status');

storeStatuses.forEach(el => {
  const rand = Math.random();

  if (rand < 0.60) {
    // 85%
    el.textContent = 'IN STOCK';
    el.classList.add('in-stock');
    el.classList.remove('low-stock', 'out-of-stock');

  } else if (rand < 0.90) {
    // 10%
    el.textContent = 'LOW STOCK';
    el.classList.add('low-stock');
    el.classList.remove('in-stock', 'out-of-stock');

  } else {
    // 5%
    el.textContent = 'OUT OF STOCK';
    el.classList.add('out-of-stock');
    el.classList.remove('in-stock', 'low-stock');
  }
});

  function showOutOfStockPopup(variantID){
    /* Two different elements hold a waitlist form, and they are addressed
       differently:

         force_out_of_stock  ->  <div id="klaviyo-oos-{variant.id}">
         a genuine stock-out ->  <div class="klaviyo-oos-{variant.id}">

       This asked for the id form only, so for a flavour that had actually
       run out it matched nothing and magnific opened an empty popup — no
       error, just a close button. Which is why it looked like the Klaviyo
       embed was missing when the metafield was set correctly all along.

       The id is tried first because when force_out_of_stock is set BOTH
       elements exist, and that one carries the override embed. */
    var src = document.getElementById('klaviyo-oos-' + variantID)
      ? '#klaviyo-oos-' + variantID
      : '.klaviyo-oos-' + variantID;

    if (!document.querySelector(src)) return;   // nothing to show; leave the CTA as it was

    $.magnificPopup.open({ items: { src: src }, type: 'inline' });
  }


  
  $(document).on('click','.selector-button',function(){

    $('.flavour-options-wrapper').slideToggle();
  });

  $('.product-info-list h3').on('click', function () {
    const $item = $(this).closest('.product-info-list');
    const isActive = $item.hasClass('active');
    $('.product-info-list').removeClass('active');
    if (!isActive) $item.addClass('active');
  });



  // Pre-select a purchase option. The ?view= offer templates show different
  // combinations, so fall back to the first VISIBLE option when the 90-day block
  // is hidden — without an .active option the checkout button stays disabled.
  /* ?offer=try-once (Google Shopping links) opens on the one-time price. It is
     checked BEFORE the offers view's own default, because /products/onefit now
     renders product.onefit-offers (#fon-buy-type), whose default is Subscribe -
     with the offers check first, try-once was never reached and the links fell
     back to Subscribe & Save. */
  var fonTryOnce = new URLSearchParams(window.location.search).get('offer') === 'try-once';
   if ($('#fon-buy-type').length) {
    // Offers view: opens on Subscribe & Save (best value) with the 90-day term,
    // or on One-time Purchase for a try-once link.
    fonSubToggle(!fonTryOnce);
    setTimeout(fonSubSaving, 1200);
   }else if (fonTryOnce) {
    $('#fon-onetime-option').trigger('click');
   }else if ($('#fon-subscription-90d-options:visible').length) {
    $('#fon-subscription-90d-options').trigger('click');
   }else{
    $('#paying-options > .fon-subscription-option:visible').first().trigger('click');
   }
  



  var $root = $('[data-ol90-popup]');
  var $closeButton = $root.find('[data-ol90-close]');
  var $upgradeButton = $root.find('[data-ol90-upgrade]');
  var $secondaryButton = $root.find('[data-ol90-secondary]');
  var $openButton = $('[data-ol90-open]');


  
  


  // openOl90Popup();


  function openOl90Popup() {


    $('.ol90-price strong').html($('[data-dynamic-value="90d-per-day"]').html());


    $root.removeClass('is-hidden');
    $('body').addClass('ol90-no-scroll');

    window.requestAnimationFrame(function () {
      $root.addClass('is-open');
    });
  }

  function closeOl90Popup() {
    $root.removeClass('is-open');
    $('body').removeClass('ol90-no-scroll');

    window.setTimeout(function () {
      $root.addClass('is-hidden');
    }, 260);
  }

  $openButton.on('click', openOl90Popup);
  $closeButton.on('click', closeOl90Popup);

  $upgradeButton.on('click', function () {
    // $upgradeButton
    //   .text('90 Day Upgrade Selected')
    //   .addClass('is-selected');

      var selectedVariant = $('.flavour-options > div.active');
      checkout90d($(this),selectedVariant);
      
  });

  $secondaryButton.on('click', function () {
    // $secondaryButton.text('One Time Option Selected');

    $upgradeButton
      .text('Upgrade And Get Results')
      .removeClass('is-selected');


       var $btn = $(this);

    // Collect selected values
    var quantityElement = $('.fon-quantity-picker.active');
    var qty = parseInt(quantityElement.attr('data-qty'));

      var selectedVariant = $('.flavour-options > div.active');
       var variantID = selectedVariant.attr('data-variant-id');
    var variantSellingPlanID = selectedVariant.attr('data-selling-plan-id');
    var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');

    // Prepare data for Shopify AJAX API
        var formData = {
          items: [
            {
              id: variantID,
              quantity: qty
            }
          ]
        };

        formData.items[0].properties = {
          _order_from : fonOrderFrom()
        };

        if (activePaymentPlan === 'subscription' && variantSellingPlanID) {
          formData.items[0].selling_plan = variantSellingPlanID;
          
        }

        // Disable button & show loading state
        var originalText = $btn.text();
        $btn.text('Adding to cart...').prop('disabled', true);

        // AJAX add to cart
        /* Open the drawer NOW, not in the success callback. It renders the cart it
           already has, so it appears immediately and fills in when the add lands.
           Waiting for /cart/add.js meant ~800-1000ms of a dead-looking click. */
        if (typeof FonCartDrawer !== 'undefined') { FonCartDrawer.openCartDrawer(true); }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify(formData),
          dataType: 'json',
          contentType: 'application/json',
          success: function (response) {
            console.log('Added to cart:', response);

            // ✅ Update and open cart drawer
            if (typeof FonCartDrawer !== 'undefined') {
              FonCartDrawer.updateCartDrawer(response);
              FonCartDrawer.openCartDrawer();
            }

            // ✅ Revert button
            $btn.text(originalText).prop('disabled', false);
          },
          error: function (xhr, status, error) {
            console.error('Error:', error);

            // ❌ Revert button
            $btn.text(originalText).prop('disabled', false);
            alert('Something went wrong. Please try again.');
          }
        });

  });

  /* ?sku= DEEP LINK: apply it as soon as the DOM is ready, not on window load.
     It used to run on load + 500ms, so a shopper watched the ad's flavour arrive
     seconds late - or never, if a third-party script held the load event. The
     work itself only needs the flavour/packaging markup and the click handlers
     bound above, both of which exist at ready.

     It still runs again on load (and the old +500ms pass) because the variant
     and price code settles late and can re-render the row; re-applying is cheap
     and idempotent - each call just re-clicks the same controls. */
  function fonApplyDeepLinkSku() {
    var params = new URLSearchParams(window.location.search);
    var tryOnce = params.get('offer') === 'try-once';
    /* Two links land here:
         ?offer=try-once&sku=SKU  Google Shopping - flavour + ONE-TIME price.
         ?flavour=SKU             our own links (the site banner) - the same
                                  format + flavour pick, purchase type left on
                                  the page default (Subscribe & Save).
       ?sku= without try-once stays ignored, as before, so ad links that carry
       it are not changed by this. */
    var sku = tryOnce ? params.get('sku') : params.get('flavour');
    if (!sku || !/^[A-Z0-9.-]+$/i.test(sku)) return;
    if (!$(`.fon-flavour[data-flavour-sku="${sku}"]`).length) return;

    if (isSachetSku(sku)) {
      $('.fon-packaging[data-packaging="sachets"]').trigger('click');
    } else if (isPouchSku(sku)) {
      $('.fon-packaging[data-packaging="pouches"]').trigger('click');
    }

    /* SELECT THE FLAVOUR THE LINK ASKED FOR, SOLD OUT OR NOT. This used to
       skip an out-of-stock flavour, which left a paid click on a DIFFERENT
       flavour from the ad with nothing to say so - the shopper saw Tropical
       after clicking a Chocolate ad. Selecting it shows that flavour, marks
       the page out of stock (body.selected-variant-oos) and swaps in the
       waitlist button, which is the honest landing for the ad. The general
       flavour click handler already does all of that; only this deep-link
       path was guarding against it. */
    $(`.fon-flavour[data-flavour-sku="${sku}"]`).trigger('click');

    // ?flavour= keeps whatever purchase type the page opened on: the format
    // and flavour clicks above do not change it.
    if (!tryOnce) return;

    // Re-assert one-time after the flavour/format clicks above. On the offers
    // view go through the row toggle, so the One-time row, the collapsed
    // cards and the selected option all agree.
    if ($('#fon-buy-type').length) fonSubToggle(false);
    else $('#fon-onetime-option').trigger('click');
  }

  fonApplyDeepLinkSku();
  $(window).on('load', function () {
    fonApplyDeepLinkSku();
    setTimeout(fonApplyDeepLinkSku, 500);
  });

  function isSachetSku(str) {
    return typeof str === 'string' && str.includes('-BOX-');
  }

  function isPouchSku(str) {
    return typeof str === 'string' && str.includes('-PCH-');
  }

});
